export default {
    // url_front: 'http://192.168.2.103:8080',
    getCookie: function(val) {
        const cookie = document.cookie || "";
        const name = val + "=";
        if (!cookie || !cookie.includes(name)) return false;

        // cookie 可能同名多份（不同 domain/path），此实现会优先返回“有效值”
        let fallback = null;
        const parts = cookie.split(";").map((s) => s.trim());
        for (let i = 0; i < parts.length; i++) {
            const item = parts[i];
            if (!item || !item.startsWith(name)) continue;

            const raw = item.substring(name.length);
            const value = (() => {
                try {
                    return decodeURIComponent(raw);
                } catch (_) {
                    return raw;
                }
            })();

            // 有些服务端错误写入会导致 value 为字符串 'undefined'，需要跳过
            if (value != null) {
                const s = String(value).trim();
                if (!s || s.toLowerCase() === "undefined" || s.toLowerCase() === "null") continue;
                return s;
            }
            if (fallback == null) fallback = raw;
        }
        return fallback && String(fallback).trim() ? String(fallback).trim() : false;
    },
    axiosFun: function(that, url, method, data, responseType) {
        let object = {
            url: url,
            method: method,
            responseType,
            // headers: {
            //   'Authorization': token
            // },
        };
        if (method == 'get') {
            object.params = data;
        } else {
            object.data = data;
        }
        return new Promise(function(reslove, reject) {
            that.Axios(object).then(function(response) {
                let res = response.data;
                if (res.status === 1) {
                    reslove(res);
                } else {
                    if (res.status === -2) {
                        that.$notify({
                            title: '错误',
                            message: '登录过期',
                            type: 'error',
                        });
                        // 清空store
                        that.$store.commit('resetUserInfo')
                            // 清除cookie
                        if (process.env.DOMAIN != null) {
                            document.cookie = 'front_token=' + ';Path=' + escape("/") + process.env.DOMAIN;
                            document.cookie = 'front_userId=' + ';Path=' + escape("/") + process.env.DOMAIN;
                            document.cookie = 'front_userName=' + ';Path=' + escape("/") + process.env.DOMAIN
                        } else {
                            document.cookie = 'front_token=' + ';Path=' + escape("/");
                            document.cookie = 'front_userId=' + ';Path=' + escape("/");
                            document.cookie = 'front_userName=' + ';Path=' + escape("/")
                        }
                        const hash = window.location.hash || '';
                        const isLargeModel = hash.indexOf('large-model') !== -1 || hash.indexOf('aigc') !== -1;
                        if (isLargeModel) {
                            window.location.hash = '#/login';
                        } else {
                            window.location.href = that.FrontUrl + '/login/';
                        }
                    } else {
                        // if(responseType) {
                        //     reslove(res)
                        // }
                        if(object.url!='/frontend/domain/pay/' && !responseType ){
                            that.$notify({
                                title: '错误',
                                message: res.error_msg,
                                type: 'error',
                            });
                        }
                        reject(res)
                    }
                }
            }).catch((err) => {
                console.log("err")
                reject(err)
            });
        });

    },
    removeAllInfo: function() {
        // token过期 清除客户登录信息
        if (process.env.DOMAIN != null) {
            document.cookie = 'front_token=' + ';Path=' + escape("/") + process.env.DOMAIN;
            document.cookie = 'front_userId=' + ';Path=' + escape("/") + process.env.DOMAIN;
            document.cookie = 'front_userName=' + ';Path=' + escape("/") + process.env.DOMAIN
        } else {
            document.cookie = 'front_token=' + ';Path=' + escape("/");
            document.cookie = 'front_userId=' + ';Path=' + escape("/");
            document.cookie = 'front_userName=' + ';Path=' + escape("/")
        }
    },

    /**
     * 日期计算加减
     * @param date (string)被加或减的日期,格式:2021-02-03
     * @param month (int) 需要加或减的月份数字
     * @returns {string}
     */
    // dateCalculation: function(date, month = 0, days = 0) {
    //     var d = new Date(date);
    //     d.setDate(d.getDate() + days);
    //     d.setMonth(d.getMonth() + month);
    //     var m = d.getMonth() + 1;
    //     var str_time = d.getFullYear() + '-' + m.toString().padStart(2, '0') + '-' + d.getDate().toString().padStart(2, '0');
    //     return str_time;
    // },
	dateCalculation: function(d, n = 0, days = 0) {
	    var t = new Date(d);
	    t.setMonth(t.getMonth() + n);
		if (t.getDate() != new Date(d).getDate()) { t.setDate(0); }
	    return t.getFullYear()+ '-' + (t.getMonth()+1).toString().padStart(2, '0') + '-' + t.getDate().toString().padStart(2, '0');
	},
    /**
     * 获取当前时间
     * 格式YYYY-MM-DD
     */
    getNowFormatDate: function() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    },
    //判断邮箱
    validateEmail(email) {
        const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    },
	// 两个日期相差天数
	getDaysBetween(dateString1, dateString2) {
	    let startDate = Date.parse(dateString1);
	    let endDate = Date.parse(dateString2);
	    return (startDate - endDate ) / (1 * 24 * 60 * 60 * 1000);
	},
	// 复杂密码校验（云服务器重装系统、重置密码）
	pwdCheck(checkStr,minLen,maxLen) {
	    let number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
		let a_z = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
			   'w', 'x', 'y', 'z']
		let A_Z = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
			   'W', 'X', 'Y', "Z"]
		let S = ['(', ')', '`', '~', '!', '@', '#', '$', '%', '^', '&', '*', '-', '+', '=', '_', '|', '{', '}', '[', ']',
			 ':', ';', '\'', '<', '>', ',', '.', '?', '/']
		if(checkStr.charAt(0) == '/'){
			return false;
		}
		if(checkStr.length < minLen || checkStr.length > maxLen){
			return false;
		}
		let all_str = number.concat(a_z).concat(A_Z).concat(S)
		let number_flag = 0
		let a_z_flag = 0
		let A_Z_flag = 0
		let S_flag = 0
		checkStr = checkStr.split('');
		for(let i of checkStr){
			if(!all_str.includes(i)){
				return false;
			}
			if(number.includes(i)){
				number_flag = 1
			}
			if(a_z.includes(i)){
				a_z_flag = 1
			}
			if(A_Z.includes(i)){
				A_Z_flag = 1
			}
			if(S.includes(i)){
				S_flag = 1
			}
		}
		if((number_flag + a_z_flag + A_Z_flag + S_flag) < 3){
			return false;
		}else{
			return true;
		}
	},
	// 云数据库账户名称校验
	rdsAccountNameCheck(checkStr,minLen,maxLen) {
	    let number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
		let a_z = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
			   'w', 'x', 'y', 'z']
		let S = ['_']
		if(checkStr.length < minLen || checkStr.length > maxLen){
			return false;
		}
		if(!a_z.includes(checkStr.charAt(0))){
			return false;
		}
		if(!a_z.includes(checkStr.charAt(checkStr.length - 1)) && !number.includes(checkStr.charAt(checkStr.length - 1))){
			return false;
		}
		let all_str = number.concat(a_z).concat(S)
		checkStr = checkStr.split('');
		for(let i of checkStr){
			if(!all_str.includes(i)){
				return false;
			}
			return true;
		}
	},
	// 云数据库账户密码校验
	rdsAccountPwdCheck(checkStr,minLen,maxLen) {
	    let number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
	    let a_z = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
	    	   'w', 'x', 'y', 'z']
	    let A_Z = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
	    	   'W', 'X', 'Y', "Z"]
	    let S = ['!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '+', '-', '=']
	    if(checkStr.length < minLen || checkStr.length > maxLen){
	    	return false;
	    }
	    let all_str = number.concat(a_z).concat(A_Z).concat(S)
	    let number_flag = 0
	    let a_z_flag = 0
	    let A_Z_flag = 0
	    let S_flag = 0
	    checkStr = checkStr.split('');
	    for(let i of checkStr){
	    	if(!all_str.includes(i)){
	    		return false;
	    	}
	    	if(number.includes(i)){
	    		number_flag = 1
	    	}
	    	if(a_z.includes(i)){
	    		a_z_flag = 1
	    	}
	    	if(A_Z.includes(i)){
	    		A_Z_flag = 1
	    	}
	    	if(S.includes(i)){
	    		S_flag = 1
	    	}
	    }
	    if((number_flag + a_z_flag + A_Z_flag + S_flag) < 4){
	    	return false;
	    }else{
	    	return true;
	    }
	},
	// 云数据库数据库名称校验
	rdsDatabaseNameCheck(checkStr,minLen,maxLen) {
	    let number = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
		let a_z = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v',
			   'w', 'x', 'y', 'z']
		let S = ['_', '-']
		if(checkStr.length < minLen || checkStr.length > maxLen){
			return false;
		}
		if(!a_z.includes(checkStr.charAt(0))){
			return false;
		}
		if(!a_z.includes(checkStr.charAt(checkStr.length - 1)) && !number.includes(checkStr.charAt(checkStr.length - 1))){
			return false;
		}
		let all_str = number.concat(a_z).concat(S)
		checkStr = checkStr.split('');
		for(let i of checkStr){
			if(!all_str.includes(i)){
				return false;
			}
			return true;
		}
	},
  getTime: function (date) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ?  '0' + (date.getMonth() + 1) :  date.getMonth() + 1;
    let day = date.getDate() < 10 ?  '0' + date.getDate():  date.getDate();
    let hour = date.getHours() < 10 ?  '0' + date.getHours() :  date.getHours();
    let minute = date.getMinutes() < 10 ?  '0' + date.getMinutes() :  date.getMinutes();
    let second = date.getSeconds() < 10 ?  '0' + date.getSeconds() :  date.getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
  },
}



// WEBPACK FOOTER //
// ./src/util/util.js